export enum OperationStatus {
    QUEUED = 'queued',
    RUNNING = 'running',
    SUCCEEDED = 'succeeded',
    PARTIAL_SUCCESS = 'partial_success',
    FAILED = 'failed',
}

export enum OperationFileStatus {
    QUEUED = 'queued',
    RUNNING = 'running',
    SUCCEEDED = 'succeeded',
    FAILED = 'failed',
}
